import { render, staticRenderFns } from "./Clusters.vue?vue&type=template&id=0c80ca36&scoped=true"
import script from "./Clusters.vue?vue&type=script&lang=js"
export * from "./Clusters.vue?vue&type=script&lang=js"
import style0 from "./Clusters.vue?vue&type=style&index=0&id=0c80ca36&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c80ca36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c80ca36')) {
      api.createRecord('0c80ca36', component.options)
    } else {
      api.reload('0c80ca36', component.options)
    }
    module.hot.accept("./Clusters.vue?vue&type=template&id=0c80ca36&scoped=true", function () {
      api.rerender('0c80ca36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/five/instrument/interestProfile/components/Clusters.vue"
export default component.exports